// Store de autenticación con Zustand. Guarda el perfil del usuario (rol incluido).
import { create } from "zustand";
import { api, setToken } from "../api/client";

export type Role = "admin" | "analyst" | "viewer" | null;

export interface Me {
  id: number;
  email: string;
  nombre: string | null;
  role: Role;
  is_active: boolean;
  /** Entró con una contraseña creada por el admin y aún no la ha cambiado. */
  debe_cambiar_password: boolean;
}

interface AuthState {
  me: Me | null;
  loading: boolean;
  loadMe: () => Promise<void>;
  /** Vuelve a leer el perfil (tras cambiar la contraseña, por ejemplo). */
  refresh: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  me: null,
  loading: false,

  loadMe: async () => {
    set({ loading: true });
    try {
      const me = await api.get<Me>("/api/me");
      set({ me, loading: false });
    } catch {
      set({ me: null, loading: false });
    }
  },

  refresh: async () => {
    try {
      set({ me: await api.get<Me>("/api/me") });
    } catch {
      // Un refresco fallido no debe tumbar la pantalla: el interceptor de 401 ya
      // saca al usuario si la sesión caducó.
    }
  },

  login: async (email, password) => {
    const { access_token } = await api.post<{ access_token: string }>("/api/login", {
      email,
      password,
    });
    setToken(access_token);
    const me = await api.get<Me>("/api/me");
    set({ me });
  },

  logout: () => {
    setToken(null);
    set({ me: null });
  },

  clear: () => set({ me: null }),
}));

export function hasRole(me: Me | null, ...roles: string[]): boolean {
  if (!me?.role) return false;
  return roles.includes(me.role);
}
